import Index1 from '../src/components/Index-1';
import page2 from '../src/components/page-2';
import Page3 from '../src/components/page-3';


const routes = [
  {
    path: '/index/:api_token',
    component: Index1,

  },
  {
    path: '/page-2',
    component: page2,

  },
  {
    path: '/page-3',
    component: Page3,

  }
];

export default routes
